export default __webpack_public_path__ + "static/media/ai-consulting-workshop.49611824.jpg";